import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const PurchasePage = () => {
  const { currentUser } = useAuth();

  useEffect(() => {
    // Redirect to main website shop page
    // Pass user email if logged in for pre-filling form
    const shopUrl = currentUser?.email 
      ? `https://memorystream.co/shop/?email=${encodeURIComponent(currentUser.email)}`
      : 'https://memorystream.co/shop/';
    
    window.location.href = shopUrl;
  }, [currentUser]);

  return (
    <div className="max-w-2xl mx-auto mt-16">
      <div className="memory-stream-card text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Redirecting to Shop...</h2>
        <p className="text-gray-600">You'll be redirected to our secure shop page in a moment.</p>
        <div className="mt-6">
          <a 
            href="https://memorystream.co/shop/" 
            className="text-blue-600 hover:text-blue-700 underline"
          >
            Click here if you're not redirected automatically
          </a>
        </div>
      </div>
    </div>
  );
};
